export function clearLocalStorage() {
  const discordName = localStorage.getItem("discordName") || "";
  localStorage.clear();
  if (discordName !== "") {
    localStorage.setItem("discordName", discordName);
  }
}
